import styled from 'styled-components';

import { Iframe, IframeFull } from 'modules/secureIframe';
import { colors, spacing } from 'ui/theme';

export const SideBySideContainer = styled.div`
  display: flex;
  height: 100%;
`;

export const DragHandle = styled.div`
  align-items: center;
  cursor: col-resize;
  display: flex;
  flex: 0 0 ${spacing.plusHalf};
  justify-content: center;
`;

export const EditorContainer = styled.div`
  border-radius: ${spacing.quarter};
  overflow: hidden;
`;

export const PreviewContainerFullHtml = styled(IframeFull)<{ height: string }>`
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.quarter};
  flex: 1 1 0;
  height: ${({ height }) => height};
  min-width: 0;
  overflow: auto;
  padding: ${spacing.half};
`;

export const PreviewContainerBodyOnly = styled(Iframe)<{ height: string }>`
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.quarter};
  flex: 1 1 0;
  height: ${({ height }) => height};
  min-width: 0;
  overflow: auto;
  padding: ${spacing.half};
`;

export const Preview = styled.div`
  width: 100%;
`;
